// @ts-strict-ignore
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { RecommendedActionsBlockData } from 'api/cms';
import { RecommendedAction } from 'api/types/shared.types';
import { Box } from 'components/Box';
import { TileCarousel } from 'components/TileCarousel';
import { State as MainState } from 'store/main';
import algoliaSearch from 'utils/algoliaSearch';
import getSearchConfig from 'utils/search/getSearchConfig';
import getSearchLocationOptions from 'utils/search/getSearchLocationOptions';
import getVolopsSearchIndex from 'utils/search/getVolopsSearchIndex';
import { listingSearchHomePath } from 'utils/searchHomePages';

const getActions = (searchLocation: SearchLocation) => {
  const searchConfig = getSearchConfig();
  let locationOptions = {};

  if (searchLocation && searchLocation.latitude && searchLocation.longitude) {
    locationOptions = getSearchLocationOptions(
      'auto',
      searchLocation
    ).locationOptions;
  }

  const queryOptions = {
    index: getVolopsSearchIndex(),
    filters: 'type:VOLOP AND source:IDEALIST',
    hitsPerPage: 20,
    attributesToRetrieve: [
      'objectID',
      'name',
      'city',
      'state',
      'logo',
      'orgName',
      'url',
    ],
    ...locationOptions,
  };
  return algoliaSearch(searchConfig, '', queryOptions)
    .then(({ hits }) => hits)
    .catch();
};

type Props = {
  data: RecommendedActionsBlockData;
};

export function RecommendedActionsBlock({ data: { headline } }: Props) {
  const searchLocation = useSelector<MainState>(
    (state) => state.mainSearch.searchLocation
  ) as SearchLocation;
  const [recommendedActions, setRecommmendedActions] = useState([]);
  useEffect(() => {
    getActions(searchLocation).then((actions: Array<RecommendedAction>) => {
      setRecommmendedActions(actions);
    });
  }, [searchLocation]);
  return (
    <Box data-qa-id="recommended-actions">
      <TileCarousel
        headline={headline}
        results={recommendedActions}
        seeAllText={
          /* TRANSLATORS: Link to actions search */
          getText('See all Actions')
        }
        seeAllUrl={`${listingSearchHomePath('VOLOP')}`}
        listingType="ACTION"
      />
    </Box>
  );
}
